import { LanguageTag } from '@zen/utils/languageSettings';
import type { Optional } from '@zen/utils/typescript';

import { isParseableAsDate, parseDate } from '../date/parsing';

export const noTimeZoneMessage: string = 'No time zone data';

export const formatTimeZone = (dateString: string, timeZone: Optional<string>): string => {
  if (!isParseableAsDate(dateString) || !timeZone) return noTimeZoneMessage;

  try {
    const parts = Intl.DateTimeFormat(LanguageTag.BritishEnglish, { timeZone, timeZoneName: 'long' }).formatToParts(
      parseDate(dateString)
    );

    return parts.find(({ type }) => type === 'timeZoneName')?.value ?? noTimeZoneMessage;
  } catch {
    return noTimeZoneMessage;
  }
};
